import { render, staticRenderFns } from "./TabsSlider.vue?vue&type=template&id=ea24342e"
import script from "./TabsSlider.vue?vue&type=script&lang=js"
export * from "./TabsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports